const Paths = {
    PATH_HOME: '/',
    PATH_PRIVACY_POLICY: '/privacy_policy',
    PATH_DEMO: '/demo',
    PATH_ADMIN_LOGIN: '/admin/login',
    PATH_ADMIN_HOME: '/admin',
    PATH_ADMIN_SHOW_BUNDLES: '/admin/bundles',
    PATH_ADMIN_EDIT_BUNDLES: '/admin/bundles/:bundleId/edit',
    PATH_ADMIN_ADD_BUNDLES: '/admin/bundles/add',
    PATH_ADMIN_SHOW_SOUNDBOXS: '/admin/soundboxs',
    PATH_ADMIN_SHOW_SOUNDBOX: '/admin/soundbox/:soundboxId',
    PATH_ADMIN_SHOW_SOUNDBOX_RENDERED: '/admin/soundbox/:soundboxId/rendered',
    PATH_ADMIN_ADD_CHARACTER: '/admin/soundbox/:soundboxId/chatacters/add',
    PATH_ADMIN_EDIT_CHARACTER: '/admin/soundbox/:soundboxId/chatacters/:characterId/edit',
    PATH_ADMIN_ADD_MOVIE: '/admin/soundbox/:soundboxId/movie/add',
    PATH_ADMIN_EDIT_MOVIE: '/admin/soundbox/:soundboxId/movie/:movieId/edit',
    PATH_ADMIN_ADD_SOUND: '/admin/soundbox/:soundboxId/sound/add',
    PATH_ADMIN_EDIT_SOUND: '/admin/soundbox/:soundboxId/sound/:soundId/edit'
};

export default Paths;